import React from "react";
import Cards from "./Cards";
import { dataLists } from "../constants/dataList";

const CardList = () => {
  const data = dataLists;
  return (
    <div className="grid lg:grid-cols-3 lg:gap-4  md:grid-cols-2">
      {data.map((item, index) => (
        <Cards
          key={index}
          title={item.title}
          description={item.description}
          image={item.image}
          link ={item.link}
          liveLink={item.liveLink}
          git={item.git}
        />
      ))}
    </div>
  );
};

export default CardList;
